import { gql } from '@apollo/client';
import { FLIGHT } from './queries';

const FLIGHTS_HOLD_RESERVATION = gql`
  ${FLIGHT}
  mutation holdFlight(
    $correlationID: String!
    $hashKey: String!
    $bookingID: String
    $guests: [HeldConfirmGuestInput]
  ) {
    holdFlight(
      input: {
        correlationID: $correlationID
        hashKey: $hashKey
        bookingID: $bookingID
        guests: $guests
      }
    ) {
      correlationID
      inboundFlight {
        ...Flight
      }
      outboundFlight {
        ...Flight
      }
      priceChange {
        pricePerPassenger {
          currency
          value
        }
        newTotal {
          currency
          value
        }
      }
    }
  }
`;

const BOOK_FLIGHT = gql`
  ${FLIGHT}
  mutation bookFlight($heldConfirmInput: HeldConfirmInput!, $paymentInput: [PaymentInput]) {
    bookFlight(heldConfirmInput: $heldConfirmInput, paymentInput: $paymentInput) {
      correlationID
      inboundFlight {
        confirmationNumbers
        ...Flight
      }
      outboundFlight {
        confirmationNumbers
        ...Flight
      }
    }
  }
`;

const BOOK_FLIGHT_AUTHORIZATION = gql`
  ${FLIGHT}
  mutation bookFlightAuthorization(
    $heldConfirmInput: HeldConfirmInput!
    $authorizationInfo: [AuthorizationInfo]
  ) {
    bookFlightAuthorization(
      heldConfirmInput: $heldConfirmInput
      authorizationInfo: $authorizationInfo
    ) {
      correlationID
      inboundFlight {
        confirmationNumbers
        ...Flight
      }
      outboundFlight {
        confirmationNumbers
        ...Flight
      }
    }
  }
`;

const EXTEND_HOLD_SESSION = gql`
  mutation extendHoldSession($input: HoldReservationInput) {
    extendHoldSession(input: $input) {
      correlationID
      message
    }
  }
`;

const CANCEL_FLIGHT = gql`
  mutation CancelFlight($input: CancelFlightInput) {
    cancelFlight(input: $input)
  }
`;

export {
  BOOK_FLIGHT,
  EXTEND_HOLD_SESSION,
  FLIGHTS_HOLD_RESERVATION,
  BOOK_FLIGHT_AUTHORIZATION,
  CANCEL_FLIGHT,
};
